/* projects/speaker-platform/src/app/organisms/conversation-messaging/conversation-messaging.component.scss */
.conversation .head-conversation {
  margin: 10px 0;
}
.conversation .head-conversation .cuppa-dropdown .selected-list .c-btn {
  border: none;
}
.conversation .head-conversation .destinataire {
  font-size: 18px;
  font-weight: 700;
}
.conversation .messages {
  min-height: 450px;
}
.conversation .messages .histo {
  display: flex;
  flex-direction: column;
  max-height: 600px;
  overflow-y: scroll;
}
.conversation .messages .histo .message {
  align-self: flex-end;
  background-color: #ffee36;
  padding: 6px 13px;
  margin: 8px;
  border-radius: 18px;
  box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.15);
  width: fit-content;
  max-width: 80%;
}
.conversation .messages .histo .desc {
  margin: 10px 8px 0 8px;
  font-size: 11px;
  font-weight: 300;
}
.conversation .messages .histo .otherDesc {
  text-align: end;
}
.conversation .messages .histo .otherMsg {
  align-self: flex-start;
  background-color: #F0F0F0;
  box-shadow: -5px 5px 10px 0 rgba(0, 0, 0, 0.15);
}
.conversation .send-new {
  margin: 13px 0;
}
.conversation .send-new .message-text {
  resize: none;
  height: 56px;
}
/*# sourceMappingURL=conversation-messaging.component-MLFD7UVH.css.map */
